module.exports = __webpack_public_path__ + "assets/img/iosicon.4559cc37.png";